import { EMPTY_SELECT_OPTION } from 'Constants/form'

import { ExchangeDeviceModalFormSchema } from './ExchangeDeviceModal.types'

export const exchangeDeviceFormDefaultValues: ExchangeDeviceModalFormSchema = {
  depot: EMPTY_SELECT_OPTION,
  depotStocklistItem: EMPTY_SELECT_OPTION,
  message: '',
}
